export default {
  audience: 'https://api.foodtrucksunited.de/',
  domain: 'foodtrucksunited.eu.auth0.com',
  clientId: 'lGkjQWNqsKvvt7ZV9eADZ8rgCFqENE9Z',
  namespace: 'https://www.wachter.biz',
  scope: 'read:interestCategories read:attachments read:categories read:devices read:foodTrucks read:partners read:spots write:attachments write:categories write:devices write:foodTrucks write:partners write:spots',
  signInCallbackUrl: `${process.env.VUE_APP_BASE_URL}/sign-in-callback`,
  signOutCallbackUrl: `${process.env.VUE_APP_BASE_URL}/sign-out-callback`
}